import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dropdown1 from '../Dropdown1'
import styles from './styles.module.scss'

function DateOfBirth({ dayOfBirth, monthOfBirth, yearOfBirth, onChange }) {
  const { t } = useTranslation()
  const [day, setDay] = useState(dayOfBirth)
  const [month, setMonth] = useState(monthOfBirth)
  const [year, setYear] = useState(yearOfBirth)

  const leapyear = (year1) => {
    const isLeapYear = year1 % 100 === 0 ? year1 % 400 === 0 : year1 % 4 === 0
    return isLeapYear
  }

  const range = (min, max) => [...Array(max - min + 1).keys()].map((i) => i + min)

  const months = [
    { value: 1, label: t('global.monthsFull.jan'), maxDays: 31 },
    { value: 2, label: t('global.monthsFull.feb'), maxDays: leapyear(year) || year === null ? 29 : 28 },
    { value: 3, label: t('global.monthsFull.mar'), maxDays: 31 },
    { value: 4, label: t('global.monthsFull.apr'), maxDays: 30 },
    { value: 5, label: t('global.monthsFull.may'), maxDays: 31 },
    { value: 6, label: t('global.monthsFull.jun'), maxDays: 30 },
    { value: 7, label: t('global.monthsFull.jul'), maxDays: 31 },
    { value: 8, label: t('global.monthsFull.aug'), maxDays: 31 },
    { value: 9, label: t('global.monthsFull.sep'), maxDays: 30 },
    { value: 10, label: t('global.monthsFull.oct'), maxDays: 31 },
    { value: 11, label: t('global.monthsFull.nov'), maxDays: 30 },
    { value: 12, label: t('global.monthsFull.dec'), maxDays: 31 }
  ].map((e) => ({ ...e }))

  const years = range(1900, 2010)
    .reverse()
    .map((e) => ({ value: e, label: e }))

  const days = range(1, month && month.maxDays ? months && months[month?.value - 1].maxDays : 31).map((e) => ({
    value: e,
    label: e
  }))

  return (
    <div className={styles.dateContainer}>
      <Dropdown1
        className={styles.selectedItemDate}
        options={days}
        placeholder={t('signup.information_module.day')}
        onChange={(e) => {
          setDay(e.value)
          onChange(e.value, month.value, year)
        }}
        value={day ? days.filter((x) => x.value == day) : null}
      />
      <Dropdown1
        customDropdownWrapper={styles.wrapperItemDateMonth}
        className={styles.selectedItemDateMonth}
        options={months}
        placeholder={t('signup.information_module.month')}
        onChange={(e) => {
          setMonth(e)
          onChange(day, e.value, year)
        }}
        value={month?.value ? months.filter((x) => x.value == month.value) : null}
      />
      <Dropdown1
        className={styles.selectedItemDateYear}
        options={years}
        placeholder={t('signup.information_module.year')}
        onChange={(e) => {
          setYear(e.value)
          onChange(day, month.value, e.value)
        }}
        value={year ? years.filter((x) => x.value == year) : null}
      />
    </div>
  )
}

export default DateOfBirth
